import { NEUTRAL_PILL_CLASS } from './statusPillColors'

// Status label/badge lookup for ProductOwnerRun rows (#916). Shared
// between AdminProductOwnerRuns.vue (builds the status filter's option
// list, #925) and ProductOwnerRunCard.vue (renders the per-card badge)
// so the label/color map lives in exactly one place instead of being
// duplicated across both.
export const PRODUCT_OWNER_RUN_STATUSES = [
  'running',
  'completed',
  'incomplete',
  'budget_refused',
  'budget_exceeded',
  'rate_limited',
  'cancelled',
  'failed',
] as const

const STATUS_LABELS: Record<string, string> = {
  running: 'Running',
  completed: 'Completed',
  incomplete: 'Incomplete',
  budget_refused: 'Budget refused',
  budget_exceeded: 'Budget exceeded',
  rate_limited: 'Rate limited',
  cancelled: 'Cancelled',
  failed: 'Failed',
}

export function productOwnerRunStatusLabel(status: string): string {
  return STATUS_LABELS[status] ?? status
}

// Mirrors the badge-color convention StatusPill.vue's callers share
// (bg-COLOR-500/15 text-COLOR-300/90|80).
const STATUS_BADGE_CLASSES: Record<string, string> = {
  running: 'bg-sky-500/15 text-sky-300/90',
  completed: 'bg-emerald-500/15 text-emerald-300/90',
  incomplete: 'bg-orange-500/15 text-orange-300/90',
  budget_refused: 'bg-yellow-500/15 text-yellow-300/80',
  budget_exceeded: 'bg-amber-500/15 text-amber-300/80',
  // The Claude account's own session limit (#1744) — not the repo's budget.
  rate_limited: 'bg-fuchsia-500/15 text-fuchsia-300/80',
  cancelled: NEUTRAL_PILL_CLASS,
  failed: 'bg-red-500/15 text-red-300/90',
}

export function productOwnerRunStatusBadgeClass(status: string): string {
  return STATUS_BADGE_CLASSES[status] ?? NEUTRAL_PILL_CLASS
}
